import React from "react";

import { Trans } from "react-i18next";
import { Icon } from "semantic-ui-react";

import PromptButton from "../../../prompt/PromptButton";

function Cancel({ onCancel, trainingUnitId, memberId }) {
  return (
    <PromptButton
      type="button"
      size="mini"
      icon
      negative
      promptType="delete"
      promptTitle={<Trans i18nKey="coursePlan.prompt.cancelRegistration" />}
      onConfirm={onCancel}
    >
      <Icon name="trash" />
    </PromptButton>
  );
}

Cancel.displayName = "coursePlan/details/registrations/Cancel";

export default React.memo(Cancel);
